/**
 * @jsx React.DOM
 * @copyright Prometheus Research, LLC 2014
 */
'use strict';

module.exports = {
  INVALID_VALUE: 'invalid value',
  VALUE_IS_REQUIRED: 'This field is required',
  AT_LEAST_ONE_ITEM_IS_REQUIRED: 'at least one item is required',
  IS_NOT_A_DATE: 'should be a date in YYYY-MM-DD format'
};



/** WEBPACK FOOTER **
 ** ./~/react-forms/lib/messages.js
 **/